import Dropdown from "rc-dropdown";
import React, { useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import {
  StyledFilterBlock, StyledFilterBlockTitle, StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup, StyledFilterWrapper, StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";
import ServicesSelect from "../../../elements/services/ServicesSelect";
import DefaultButton from "../../../styles/materialButtonStyle";
import ExclusionTypesSelect from "../../../elements/ServiceExclusions/New/ExclusionTypesSelect";
import ExclusionNamesSelect from "../../../elements/ServiceExclusions/New/ExclusionNamesSelect";

const ServiceExclusionFilter = ({ filterData, setFilterData, t }) => {
  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "currentTab": filterData["currentTab"],
    "name": null,
    "type": null,
    "exclusionValues": "",
    "service.name": null,
    "itemsPerPage": filterData["itemsPerPage"] ?? null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="close-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledFilterGroup>
                <ExclusionNamesSelect
                  t={t}
                  checkedName={filterData["name"]}
                  setCheckedName={(data) => setFilterData({
                    ...filterData,
                    "name": data,
                    page: 1
                  })}
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="country">
                  {t("exclusions.table.value")}
                </label>
                <DelayInput
                  id="exclusionValues"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "exclusionValues": event.target.value, page: 1 })}
                  name="exclusionValues"
                  value={filterData["exclusionValues"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <ServicesSelect
                  checkedService={filterData["service.name"]}
                  setCheckedService={(data) => setFilterData({
                    ...filterData,
                    "service.name": data,
                    page: 1
                  })}
                  isObject={false}
                  defaultOption={true}
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <ExclusionTypesSelect
                  t={t}
                  checkedType={filterData["type"]}
                  setCheckedType={(data) => setFilterData({
                    ...filterData,
                    "type": data,
                    page: 1
                  })}
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default ServiceExclusionFilter;